export const GET_ANALYTICS = "GET_ANALYTICS";
export const ANALYTICS_LOADING = "ANALYTICS_LOADING";